// ----------------------------------------------------------------------
// <copyright file="Izenda.Connection.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * @module Connection component
 */

import React, { Component, PropTypes } from 'react';
import ConnectionConfig from './ConnectionConfig/Izenda.ConnectionConfig';
import ConnectionList from './ConnectionList/Izenda.ConnectionList';
import MiddlePanel from 'share/components/layout/Izenda.MiddlePanel';
import connect from 'share/enhancers/Izenda.Connect';
import actions from './Izenda.ConnectionActions';
import constants from 'logic/data/Izenda.ConnectionConstants';

@connect(actions)
export default class Connection extends Component {
  static propTypes = {
    onSaveCallback: PropTypes.func
  };

  componentWillUnmount() {
    const { props } = this;
    props.masterStore.dispose();
    props.masterStore.disposeChangeTenant();
  }

  render() {
    const { props } = this;

    return (
      <div className="izenda-TableLayout">
        <MiddlePanel ref="connectionsPanel">
          <ConnectionList
            store={props.masterStore}
          />
        </MiddlePanel>

        <ConnectionConfig
          connectionDetailStore={props.detailStore}
          item={props.detailStore.item}
          dbTypeList={props.masterStore.dbTypeList}
          testConnectionFn={props.testConnection}
          connectToDataSourceFn={props.connectToDataSource}
          onSaveCallback={props.onSaveCallback}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Connection/Izenda.Connection.js